/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { inventoryGetActivities } from '../fn/inventory-activities-controller/inventory-get-activities';
import { InventoryGetActivities$Params } from '../fn/inventory-activities-controller/inventory-get-activities';
import { inventoryGetRecentActivities } from '../fn/inventory-activities-controller/inventory-get-recent-activities';
import { InventoryGetRecentActivities$Params } from '../fn/inventory-activities-controller/inventory-get-recent-activities';
import { UserActivityWithRelations } from '../models/user-activity-with-relations';

@Injectable({ providedIn: 'root' })
export class InventoryActivitiesControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userActivityControllerInventoryGetRecentActivities()` */
  static readonly UserActivityControllerInventoryGetRecentActivitiesPath = '/inventory/activities/recent';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inventoryGetRecentActivities()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryGetRecentActivities$Response(params: InventoryGetRecentActivities$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserActivityWithRelations>>> {
    return inventoryGetRecentActivities(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inventoryGetRecentActivities$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryGetRecentActivities(params: InventoryGetRecentActivities$Params, context?: HttpContext): Observable<Array<UserActivityWithRelations>> {
    return this.inventoryGetRecentActivities$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserActivityWithRelations>>): Array<UserActivityWithRelations> => r.body)
    );
  }

  /** Path part for operation `userActivityControllerInventoryGetActivities()` */
  static readonly UserActivityControllerInventoryGetActivitiesPath = '/inventory/activities';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inventoryGetActivities()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryGetActivities$Response(params: InventoryGetActivities$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserActivityWithRelations>>> {
    return inventoryGetActivities(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inventoryGetActivities$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryGetActivities(params: InventoryGetActivities$Params, context?: HttpContext): Observable<Array<UserActivityWithRelations>> {
    return this.inventoryGetActivities$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserActivityWithRelations>>): Array<UserActivityWithRelations> => r.body)
    );
  }

}
